// material-ui
import { List, Typography } from "@mui/material";

// types
import { NavItemType } from "@/types/menu";

// project import
import NavItem from "./NavItem";

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

const NavGroup = ({ item }: { item: NavItemType }) => {
  const supportClickHandler = () => {
    const email = "hey@aigency.ai";
    const subject = encodeURIComponent("Aigency Portal Help & Support");
    window.location.href = `mailto:${email}?subject=${subject}`;
  };

  const navCollapse = item.children?.map((menuItem) => {
    switch (menuItem.type) {
      case "collapse":
        return (
          <Typography key={menuItem.id} variant="caption" color="error" sx={{ p: 2.5 }}>
            collapse - only available in paid version
          </Typography>
        );
      case "item":
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      case "support":
        return (
          <NavItem key={menuItem.id} item={menuItem} level={1} onClick={supportClickHandler} />
        );
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return <List sx={{ py: 0, zIndex: 0 }}>{navCollapse}</List>;
};

export default NavGroup;
